import React from "react"
import { graphql } from "gatsby"
import LayoutLanding from '../layout/layoutlanding'
import Head from '../components/head'
import * as Sections from '../sections/_all'

export default function Template({
  data, // this prop will be injected by the GraphQL query below.
}) {
  const { yamlLanding, yamlHeaderSimple, yamlFooterSimple } = data
  

/*   const importSectionByType = (sectionType) => {
    console.log('Impoting section... ' + sectionType)
    return import(`../sections/${sectionType}`).catch(() =>
      import(`../sections/Hero`))
  } */

  const renderSections = yamlLanding.sections.map( (section, index) => {
    const Section = Sections[section.type];
    return Section ? <Section key={index} payload={section} /> : null
  })

  return (
    <LayoutLanding className='max-w1440' headerProps={yamlHeaderSimple} footerProps={yamlFooterSimple}>
      <Head title={yamlLanding.title}/>
      <div id="sections-container">
        {renderSections}
      </div>
    </LayoutLanding>
  )
}

export const pageQuery = graphql`
  query getLandingInfo($slug: String!) {
    yamlLanding(slug: { eq: $slug }) {
      title
      sections {
        type
        id
        style
        number
        title
        ...calendly
        ...identify
        ...toDoSection
        ...together
        ...products
        ...team
        ...faq
        ...landingwelcome
        ...badges
      }
    }

    yamlHeaderSimple {
      logo: logo___Image_ {
        path
        alt
      }
      items {
        title
        href
      }
    }

    yamlFooterSimple {
      style
      offices {
        city
        country
        image: image___Image_ {
          path
        }
      }
      links {
        label
        href
        type
      }
      copyright
    }
  }

  fragment calendly on YamlLandingSections {
    calendly {
      url
    }
  }

  fragment identify on YamlLandingSections {
    identify {
      title
      items {
        icon
        alt
        bold
        text
      }
      cta {
        label
        href
      }
      image {
        path
        alt
      }
    }
  }

  fragment toDoSection on YamlLandingSections {
    toDo {
      title
      paragraphs
      cta {
        label
        href
      }
    }
  }

  fragment together on YamlLandingSections {
    together {
      title
      cards {
        icon
        title
        text
      }
      cta {
        label
        href
      }
    }
  }

  fragment products on YamlLandingSections {
    products {
      title
      images {
        src
        url
      }
      cta {
        label
        href
      }
    }
  }

  fragment team on YamlLandingSections {
    team {
      title
      paragraphs
      cta {
        label
        href
      }
    }
  }

  fragment faq on YamlLandingSections {
    faq {
      title
      items {
        question
        answer
      }
      cta {
        label
        href
      }
    }
  }

  fragment landingwelcome on YamlLandingSections {
    landingwelcome {
      title
      subtitle
      description
      cta {
        label
        href
      }
    }
  }

  fragment badges on YamlLandingSections {
    badges {
      title
      images
    }
  }

`;
